import React from "react";
// import * as Yup from "yup";

import Form from "@Components/Form";
import { MOHR_BRANCH_URL, URLS } from "configs/constants";

const initialValues = {
  branch_name: "",
  territory: "",
  state: "",
  district: "",
  address: "",
  location: "",
  contact_number: "",
  is_headquarter: true,
  active: true,
};

const BranchDetail = () => {
  const formFields = [
    {
      type: "renderonly",
      name: "branch_name",
      label: "Branch Name",
      key: "branch_name",
      required: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "territory",
      label: "Territory",
      key: "territory",
      // proxyUrl: MOHR_TERRITORIES_URL,
      required: true,
      paginated: false,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "state",
      label: "State",
      key: "state_name",
      // proxyUrl: STATE_FETCH_URL,
      paginated: true,
      required: true,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "district",
      label: "District",
      key: "district_name",
      // proxyUrl: DISTRICT_FETCH_URL,
      paginated: true,
      required: true,
      optionsDependsOn: "state",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "address",
      label: "Address",
      key: "address",
      required: true,
      multiline: true,
      rows: 3,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "contact_number",
      label: "Contact Numbers(Separated By Comma)",
      key: "contact_number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
      multiline: true,
    },
    {
      type: "renderonly",
      name: "location",
      label: "Map Geolocation",
      required: true,
      multiline: true,
      key: "location",
      formType: "Edit",
      rows: 3,
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "is_headquarter",
      label: "Headquarter?",
      key: "is_headquarter",
      valueType: "boolean",
      noValue: "No",
      yesValue: "Yes",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "active",
      label: "Active?",
      key: "active",
      valueType: "boolean",
      noValue: "No",
      yesValue: "Yes",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
  ];

  const formButtons = ["cancel"];

  return (
    <Form
      initialValues={initialValues}
      submitUrl={MOHR_BRANCH_URL}
      listRoute={URLS.MOHR_LIST}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Branch Setup"
    />
  );
};

export default BranchDetail;
